<div class="rating-grid">
    <span class="app-star">
        <div class="score-wrap">
            <span class="stars-active" [style.width.%]="getRatingInPercent">
                <div class="dis-flx">
                    <span *ngFor="let stars of starArray" class="fa fa-star" aria-hidden="true"
                        (click)="clickOnStar(stars)" (mouseenter)="hover(stars)" (mouseleave)="leave()" [class]="{
                            bigger: this.bigger,
                            veryBig: this.veryBig,
                            color: this.color
                        }"></span>
                </div>
            </span>
            <span class="stars-inactive">
                <span *ngFor="let stars of starArray" class="fa fa-star-o" aria-hidden="true"
                    (click)="clickOnStar(stars)" (mouseenter)="hover(stars)" (mouseleave)="leave()" [class]="{
                        bigger: this.bigger,
                        veryBig: this.veryBig,
                        color: this.color
                    }"></span>
            </span>
        </div>
    </span>
    <div *ngIf="ratingCount != null" class="rating-count">
        {{ ratingCount }}
    </div>
</div>